import React, { Component } from "react";
import "semantic-ui-css/semantic.min.css";
import {
  Container,
  Header,
  List,
  Grid,
  Icon,
  Table,
  Accordion,
  Segment,
  Image,
} from "semantic-ui-react";
import MainMenu from "./components/MainMenu";
import logo from "./logo.png";
import "./App.css";

class App extends Component {
  state = { activeIndex: 0 };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    return (
      <div>
        <br />
        <br />
        <center>
          <h1>Website under construction! 😃🚧</h1>
        </center>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js